import axios from "axios";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import { useLocation } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import github from "../../assets/images/github.png";
import { Context } from "../../context";
import classes from "./Demo.module.css";
import DemoCard from "./DemoCard";
import IconFilter from "./IconFilter";
const url = "https://demo-api.davidebalice.dev/api/demos?limit=1000";

const Demo = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [overlay, setOverlay] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [makeScroll, setMakeScroll] = useState(false);
  const itemsPerPage = 8;
  const [demoData, setDemoData] = useState([]);
  const demoSectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { debug, lang } = useContext(Context);
  const containerRefs = useRef([]);
  const location = useLocation();

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const openPopupCard = (e, info, card) => {
    setSelectedCard(card);
    setOverlay(true);
  };

  const handleCloseCard = () => {
    setSelectedCard(null);
    setOverlay(false);
  };

  const getData = async (filter = null) => {
    let requestUrl = url;
    if (filter) {
      requestUrl += `&filter=${filter}`;
    }
    const response = await axios.get(requestUrl);

    if (filter && filter !== "all") {
      const filteredData = response.data.demos.filter((item) =>
        item.tecnology.includes(filter)
      );
      setCurrentPage(1);
      setDemoData(filteredData);
    } else {
      setDemoData(response.data.demos);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  let delay = 0;

  const handleIconFilter = (filter) => {
    getData(filter);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = demoData
    .sort((a, b) => a.order - b.order)
    .slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(demoData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setMakeScroll(true);
  };

  const queryParams = new URLSearchParams(location.search);
  const view = queryParams.get("view");

  useEffect(() => {
    if (demoSectionRef.current && makeScroll) {
      if (demoSectionRef.current) {
        demoSectionRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [view, currentPage, demoData]);

  return (
    <>
      {overlay && <div className={classes.overlay}></div>}
      <section id="demoHome" className={`${classes.demoHome} section p_zero`}>
        <div className="text-center py-5">
          <div className="container">
            <VisibilitySensor
              onChange={changeVisibility}
              partialVisibility
              delayedCall
            >
              <a
                href="https://github.com/davidebalice"
                target="_blank"
                alt="github davide"
                rel="noreferrer"
              >
                <motion.img
                  initial={{ opacity: 0, y: 12 }}
                  animate={{
                    opacity: isVisible ? 1 : 0,
                    y: isVisible ? 0 : 20,
                  }}
                  transition={{ duration: 0.4, delay: 0.5 }}
                  src={github}
                  style={{ width: "180px" }}
                ></motion.img>
              </a>
            </VisibilitySensor>

            <VisibilitySensor
              onChange={changeVisibility}
              partialVisibility
              delayedCall
            >
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{
                  opacity: isVisible ? 1 : 0,
                  y: isVisible ? 0 : 20,
                }}
                transition={{ duration: 0.4, delay: 0.8 }}
                className="text-5 text-dark w-100 align-self-center lh-base mb-4"
              >
                {lang === "en" && <>Repository on GitHub</>}
                {lang === "it" && <>Repository su GitHub</>}
              </motion.p>
            </VisibilitySensor>

            <VisibilitySensor
              onChange={changeVisibility}
              partialVisibility
              delayedCall
            >
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{
                  opacity: isVisible ? 1 : 0,
                }}
                transition={{ duration: 0.4, delay: 1.11 }}
                className={`text-4 text-dark w-100 align-self-center text-start lh-base mb-0 mt-5 m-auto ${classes.demoText}`}
              >
                {lang === "en" && (
                  <>
                    The <strong className={classes.boldText}>demos</strong> are
                    built using modern technologies and serve as examples of
                    what can be achieved. They are intended for{" "}
                    <strong className={classes.boldText}>study purposes</strong>
                    , some projects were initiated during{" "}
                    <strong className={classes.boldText}>online courses</strong>{" "}
                    and then continued and improved, while others were developed{" "}
                    <strong className={classes.boldText}>purely for fun</strong>
                    . Backend access is limited, as a{" "}
                    <strong className={classes.boldText}>DEMO MODE</strong> has
                    been implemented via middleware to prevent CRUD operations.
                    <br />
                    All source code is available on my <strong>GitHub</strong>
                  </>
                )}
                {lang === "it" && (
                  <>
                    Le <strong className={classes.boldText}>demo</strong> sono
                    realizzate utilizzando tecnologie moderne e rappresentano
                    solo esempi delle possibilità di sviluppo. Sono create{" "}
                    <strong className={classes.boldText}>
                      a scopo didattico
                    </strong>
                    : alcuni progetti sono stati avviati durante
                    <strong className={classes.boldText}>
                      {" "}
                      corsi online
                    </strong>{" "}
                    e successivamente proseguiti e migliorati, mentre altre demo
                    sono state sviluppate{" "}
                    <strong className={classes.boldText}>
                      per divertimento
                    </strong>
                    . L'accesso al backend è parziale, poiché è stata attivata
                    una <strong className={classes.boldText}>DEMO MODE </strong>
                    tramite middleware che impedisce le operazioni CRUD.
                    <br />
                    Tutto il codice sorgente è disponibile sul mio{" "}
                    <strong> GitHub</strong>.
                  </>
                )}
              </motion.p>
            </VisibilitySensor>
          </div>
        </div>
        <Container
          ref={demoSectionRef}
          fluid
          className={`${classes.demoCardContainer} text-center`}
        >
          <div className={`${classes.iconContainer}`}>
            <IconFilter
              onFilter={handleIconFilter}
              setMakeScroll={setMakeScroll}
            />
          </div>

          <div className={`${classes.topLinea}`}></div>

          <div className="pagination paginationTop">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={currentPage === 1 ? "button-disabled" : ""}
            >
              {`<`}
            </button>

            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                className={index + 1 === currentPage ? "button-active" : ""}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={currentPage === totalPages ? "button-disabled" : ""}
            >
              {`>`}
            </button>
          </div>

          <div className="row gx-4 mx-lg-4 demo">
            {demoData && demoData.length === 0 ? (
              <p className="pt-5">No demo found</p>
            ) : (
              currentItems &&
              currentItems
                .sort((a, b) => a.order - b.order)
                .map((item) => {
                  delay = delay + 0.1;
                  return (
                    <DemoCard
                      key={item.title}
                      {...item}
                      card={item}
                      delay={delay}
                      selectedCard={selectedCard}
                      openPopupCard={openPopupCard}
                      containerRefs={containerRefs}
                      handleCloseCard={handleCloseCard}
                    />
                  );
                })
            )}
          </div>
        </Container>

        <div className="pagination">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={currentPage === 1 ? "button-disabled" : ""}
          >
            {`<`}
          </button>

          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => handlePageChange(index + 1)}
              className={index + 1 === currentPage ? "button-active" : ""}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={currentPage === totalPages ? "button-disabled" : ""}
          >
            {`>`}
          </button>
        </div>
      </section>
    </>
  );
};

export default Demo;
